"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _block_ai_learning = require("./block_ai_learning");
module.exports = {
  getBlocks: function getBlocks() {
    return {
      learning_title_number: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_number_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_number'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_number'],
        events: {}
      },
      set_number_learning_option_k: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [10, null],
          type: 'set_number_learning_option_k'
        },
        pyHelpDef: {
          params: [],
          type: 'set_number_learning_option_k'
        },
        paramsKeyMap: {
          VALUE: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_number'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var value;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  value = script.getNumberValue('VALUE', script);
                  Entry.aiLearning.setTrainOption('neighbors', parseInt(value));
                  return _context.abrupt("return", script.callReturn());
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_1: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning, _Entry$aiLearning$get;
            var table = (_Entry$aiLearning = Entry.aiLearning) === null || _Entry$aiLearning === void 0 || (_Entry$aiLearning$get = _Entry$aiLearning.getTableData) === null || _Entry$aiLearning$get === void 0 ? void 0 : _Entry$aiLearning$get.call(_Entry$aiLearning);
            if (table) {
              var _Entry$aiLearning2, _Entry$aiLearning2$ge, _select$;
              var _Entry$aiLearning$get2 = (_Entry$aiLearning2 = Entry.aiLearning) === null || _Entry$aiLearning2 === void 0 || (_Entry$aiLearning2$ge = _Entry$aiLearning2.getTableData) === null || _Entry$aiLearning2$ge === void 0 ? void 0 : _Entry$aiLearning2$ge.call(_Entry$aiLearning2),
                _Entry$aiLearning$get3 = _Entry$aiLearning$get2.select,
                select = _Entry$aiLearning$get3 === void 0 ? [] : _Entry$aiLearning$get3,
                _Entry$aiLearning$get4 = _Entry$aiLearning$get2.fields,
                fields = _Entry$aiLearning$get4 === void 0 ? [] : _Entry$aiLearning$get4;
              return fields[select === null || select === void 0 || (_select$ = select[0]) === null || _select$ === void 0 ? void 0 : _select$[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_1'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_1'
        },
        paramsKeyMap: {
          ATTR1: 1
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_1'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var x, _Entry$aiLearning$get5, _Entry$aiLearning$get6, className;
            return _regenerator["default"].wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  _context2.next = 1;
                  return Entry.aiLearning.predict([x]);
                case 1:
                  _Entry$aiLearning$get5 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get6 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get5, 1), className = _Entry$aiLearning$get6[0].className;
                  return _context2.abrupt("return", className);
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_2: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning3, _Entry$aiLearning3$ge;
            var table = (_Entry$aiLearning3 = Entry.aiLearning) === null || _Entry$aiLearning3 === void 0 || (_Entry$aiLearning3$ge = _Entry$aiLearning3.getTableData) === null || _Entry$aiLearning3$ge === void 0 ? void 0 : _Entry$aiLearning3$ge.call(_Entry$aiLearning3);
            if (table) {
              var _Entry$aiLearning4, _Entry$aiLearning4$ge, _select$2;
              var _Entry$aiLearning$get7 = (_Entry$aiLearning4 = Entry.aiLearning) === null || _Entry$aiLearning4 === void 0 || (_Entry$aiLearning4$ge = _Entry$aiLearning4.getTableData) === null || _Entry$aiLearning4$ge === void 0 ? void 0 : _Entry$aiLearning4$ge.call(_Entry$aiLearning4),
                _Entry$aiLearning$get8 = _Entry$aiLearning$get7.select,
                select = _Entry$aiLearning$get8 === void 0 ? [] : _Entry$aiLearning$get8,
                _Entry$aiLearning$get9 = _Entry$aiLearning$get7.fields,
                fields = _Entry$aiLearning$get9 === void 0 ? [] : _Entry$aiLearning$get9;
              return fields[select === null || select === void 0 || (_select$2 = select[0]) === null || _select$2 === void 0 ? void 0 : _select$2[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning5, _Entry$aiLearning5$ge;
            var table = (_Entry$aiLearning5 = Entry.aiLearning) === null || _Entry$aiLearning5 === void 0 || (_Entry$aiLearning5$ge = _Entry$aiLearning5.getTableData) === null || _Entry$aiLearning5$ge === void 0 ? void 0 : _Entry$aiLearning5$ge.call(_Entry$aiLearning5);
            if (table) {
              var _Entry$aiLearning6, _Entry$aiLearning6$ge, _select$3;
              var _Entry$aiLearning$get0 = (_Entry$aiLearning6 = Entry.aiLearning) === null || _Entry$aiLearning6 === void 0 || (_Entry$aiLearning6$ge = _Entry$aiLearning6.getTableData) === null || _Entry$aiLearning6$ge === void 0 ? void 0 : _Entry$aiLearning6$ge.call(_Entry$aiLearning6),
                _Entry$aiLearning$get1 = _Entry$aiLearning$get0.select,
                select = _Entry$aiLearning$get1 === void 0 ? [] : _Entry$aiLearning$get1,
                _Entry$aiLearning$get10 = _Entry$aiLearning$get0.fields,
                fields = _Entry$aiLearning$get10 === void 0 ? [] : _Entry$aiLearning$get10;
              return fields[select === null || select === void 0 || (_select$3 = select[0]) === null || _select$3 === void 0 ? void 0 : _select$3[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_2'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_2'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_2'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            var x, y, _Entry$aiLearning$get11, _Entry$aiLearning$get12, className;
            return _regenerator["default"].wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  _context3.next = 1;
                  return Entry.aiLearning.predict([x, y]);
                case 1:
                  _Entry$aiLearning$get11 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get12 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get11, 1), className = _Entry$aiLearning$get12[0].className;
                  return _context3.abrupt("return", className);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_3: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning7, _Entry$aiLearning7$ge;
            var table = (_Entry$aiLearning7 = Entry.aiLearning) === null || _Entry$aiLearning7 === void 0 || (_Entry$aiLearning7$ge = _Entry$aiLearning7.getTableData) === null || _Entry$aiLearning7$ge === void 0 ? void 0 : _Entry$aiLearning7$ge.call(_Entry$aiLearning7);
            if (table) {
              var _Entry$aiLearning8, _Entry$aiLearning8$ge, _select$4;
              var _Entry$aiLearning$get13 = (_Entry$aiLearning8 = Entry.aiLearning) === null || _Entry$aiLearning8 === void 0 || (_Entry$aiLearning8$ge = _Entry$aiLearning8.getTableData) === null || _Entry$aiLearning8$ge === void 0 ? void 0 : _Entry$aiLearning8$ge.call(_Entry$aiLearning8),
                _Entry$aiLearning$get14 = _Entry$aiLearning$get13.select,
                select = _Entry$aiLearning$get14 === void 0 ? [] : _Entry$aiLearning$get14,
                _Entry$aiLearning$get15 = _Entry$aiLearning$get13.fields,
                fields = _Entry$aiLearning$get15 === void 0 ? [] : _Entry$aiLearning$get15;
              return fields[select === null || select === void 0 || (_select$4 = select[0]) === null || _select$4 === void 0 ? void 0 : _select$4[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning9, _Entry$aiLearning9$ge;
            var table = (_Entry$aiLearning9 = Entry.aiLearning) === null || _Entry$aiLearning9 === void 0 || (_Entry$aiLearning9$ge = _Entry$aiLearning9.getTableData) === null || _Entry$aiLearning9$ge === void 0 ? void 0 : _Entry$aiLearning9$ge.call(_Entry$aiLearning9);
            if (table) {
              var _Entry$aiLearning0, _Entry$aiLearning0$ge, _select$5;
              var _Entry$aiLearning$get16 = (_Entry$aiLearning0 = Entry.aiLearning) === null || _Entry$aiLearning0 === void 0 || (_Entry$aiLearning0$ge = _Entry$aiLearning0.getTableData) === null || _Entry$aiLearning0$ge === void 0 ? void 0 : _Entry$aiLearning0$ge.call(_Entry$aiLearning0),
                _Entry$aiLearning$get17 = _Entry$aiLearning$get16.select,
                select = _Entry$aiLearning$get17 === void 0 ? [] : _Entry$aiLearning$get17,
                _Entry$aiLearning$get18 = _Entry$aiLearning$get16.fields,
                fields = _Entry$aiLearning$get18 === void 0 ? [] : _Entry$aiLearning$get18;
              return fields[select === null || select === void 0 || (_select$5 = select[0]) === null || _select$5 === void 0 ? void 0 : _select$5[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning1, _Entry$aiLearning1$ge;
            var table = (_Entry$aiLearning1 = Entry.aiLearning) === null || _Entry$aiLearning1 === void 0 || (_Entry$aiLearning1$ge = _Entry$aiLearning1.getTableData) === null || _Entry$aiLearning1$ge === void 0 ? void 0 : _Entry$aiLearning1$ge.call(_Entry$aiLearning1);
            if (table) {
              var _Entry$aiLearning10, _Entry$aiLearning10$g, _select$6;
              var _Entry$aiLearning$get19 = (_Entry$aiLearning10 = Entry.aiLearning) === null || _Entry$aiLearning10 === void 0 || (_Entry$aiLearning10$g = _Entry$aiLearning10.getTableData) === null || _Entry$aiLearning10$g === void 0 ? void 0 : _Entry$aiLearning10$g.call(_Entry$aiLearning10),
                _Entry$aiLearning$get20 = _Entry$aiLearning$get19.select,
                select = _Entry$aiLearning$get20 === void 0 ? [] : _Entry$aiLearning$get20,
                _Entry$aiLearning$get21 = _Entry$aiLearning$get19.fields,
                fields = _Entry$aiLearning$get21 === void 0 ? [] : _Entry$aiLearning$get21;
              return fields[select === null || select === void 0 || (_select$6 = select[0]) === null || _select$6 === void 0 ? void 0 : _select$6[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_3'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_3'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_3'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
            var x, y, z, _Entry$aiLearning$get22, _Entry$aiLearning$get23, className;
            return _regenerator["default"].wrap(function (_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  z = script.getNumberValue('ATTR3', script);
                  _context4.next = 1;
                  return Entry.aiLearning.predict([x, y, z]);
                case 1:
                  _Entry$aiLearning$get22 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get23 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get22, 1), className = _Entry$aiLearning$get23[0].className;
                  return _context4.abrupt("return", className);
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_4: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning11, _Entry$aiLearning11$g;
            var table = (_Entry$aiLearning11 = Entry.aiLearning) === null || _Entry$aiLearning11 === void 0 || (_Entry$aiLearning11$g = _Entry$aiLearning11.getTableData) === null || _Entry$aiLearning11$g === void 0 ? void 0 : _Entry$aiLearning11$g.call(_Entry$aiLearning11);
            if (table) {
              var _Entry$aiLearning12, _Entry$aiLearning12$g, _select$7;
              var _Entry$aiLearning$get24 = (_Entry$aiLearning12 = Entry.aiLearning) === null || _Entry$aiLearning12 === void 0 || (_Entry$aiLearning12$g = _Entry$aiLearning12.getTableData) === null || _Entry$aiLearning12$g === void 0 ? void 0 : _Entry$aiLearning12$g.call(_Entry$aiLearning12),
                _Entry$aiLearning$get25 = _Entry$aiLearning$get24.select,
                select = _Entry$aiLearning$get25 === void 0 ? [] : _Entry$aiLearning$get25,
                _Entry$aiLearning$get26 = _Entry$aiLearning$get24.fields,
                fields = _Entry$aiLearning$get26 === void 0 ? [] : _Entry$aiLearning$get26;
              return fields[select === null || select === void 0 || (_select$7 = select[0]) === null || _select$7 === void 0 ? void 0 : _select$7[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning13, _Entry$aiLearning13$g;
            var table = (_Entry$aiLearning13 = Entry.aiLearning) === null || _Entry$aiLearning13 === void 0 || (_Entry$aiLearning13$g = _Entry$aiLearning13.getTableData) === null || _Entry$aiLearning13$g === void 0 ? void 0 : _Entry$aiLearning13$g.call(_Entry$aiLearning13);
            if (table) {
              var _Entry$aiLearning14, _Entry$aiLearning14$g, _select$8;
              var _Entry$aiLearning$get27 = (_Entry$aiLearning14 = Entry.aiLearning) === null || _Entry$aiLearning14 === void 0 || (_Entry$aiLearning14$g = _Entry$aiLearning14.getTableData) === null || _Entry$aiLearning14$g === void 0 ? void 0 : _Entry$aiLearning14$g.call(_Entry$aiLearning14),
                _Entry$aiLearning$get28 = _Entry$aiLearning$get27.select,
                select = _Entry$aiLearning$get28 === void 0 ? [] : _Entry$aiLearning$get28,
                _Entry$aiLearning$get29 = _Entry$aiLearning$get27.fields,
                fields = _Entry$aiLearning$get29 === void 0 ? [] : _Entry$aiLearning$get29;
              return fields[select === null || select === void 0 || (_select$8 = select[0]) === null || _select$8 === void 0 ? void 0 : _select$8[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning15, _Entry$aiLearning15$g;
            var table = (_Entry$aiLearning15 = Entry.aiLearning) === null || _Entry$aiLearning15 === void 0 || (_Entry$aiLearning15$g = _Entry$aiLearning15.getTableData) === null || _Entry$aiLearning15$g === void 0 ? void 0 : _Entry$aiLearning15$g.call(_Entry$aiLearning15);
            if (table) {
              var _Entry$aiLearning16, _Entry$aiLearning16$g, _select$9;
              var _Entry$aiLearning$get30 = (_Entry$aiLearning16 = Entry.aiLearning) === null || _Entry$aiLearning16 === void 0 || (_Entry$aiLearning16$g = _Entry$aiLearning16.getTableData) === null || _Entry$aiLearning16$g === void 0 ? void 0 : _Entry$aiLearning16$g.call(_Entry$aiLearning16),
                _Entry$aiLearning$get31 = _Entry$aiLearning$get30.select,
                select = _Entry$aiLearning$get31 === void 0 ? [] : _Entry$aiLearning$get31,
                _Entry$aiLearning$get32 = _Entry$aiLearning$get30.fields,
                fields = _Entry$aiLearning$get32 === void 0 ? [] : _Entry$aiLearning$get32;
              return fields[select === null || select === void 0 || (_select$9 = select[0]) === null || _select$9 === void 0 ? void 0 : _select$9[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning17, _Entry$aiLearning17$g;
            var table = (_Entry$aiLearning17 = Entry.aiLearning) === null || _Entry$aiLearning17 === void 0 || (_Entry$aiLearning17$g = _Entry$aiLearning17.getTableData) === null || _Entry$aiLearning17$g === void 0 ? void 0 : _Entry$aiLearning17$g.call(_Entry$aiLearning17);
            if (table) {
              var _Entry$aiLearning18, _Entry$aiLearning18$g, _select$0;
              var _Entry$aiLearning$get33 = (_Entry$aiLearning18 = Entry.aiLearning) === null || _Entry$aiLearning18 === void 0 || (_Entry$aiLearning18$g = _Entry$aiLearning18.getTableData) === null || _Entry$aiLearning18$g === void 0 ? void 0 : _Entry$aiLearning18$g.call(_Entry$aiLearning18),
                _Entry$aiLearning$get34 = _Entry$aiLearning$get33.select,
                select = _Entry$aiLearning$get34 === void 0 ? [] : _Entry$aiLearning$get34,
                _Entry$aiLearning$get35 = _Entry$aiLearning$get33.fields,
                fields = _Entry$aiLearning$get35 === void 0 ? [] : _Entry$aiLearning$get35;
              return fields[select === null || select === void 0 || (_select$0 = select[0]) === null || _select$0 === void 0 ? void 0 : _select$0[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_4'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_4'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_4'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
            var a, b, c, d, _Entry$aiLearning$get36, _Entry$aiLearning$get37, className;
            return _regenerator["default"].wrap(function (_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  _context5.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d]);
                case 1:
                  _Entry$aiLearning$get36 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get37 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get36, 1), className = _Entry$aiLearning$get37[0].className;
                  return _context5.abrupt("return", className);
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_5: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning19, _Entry$aiLearning19$g;
            var table = (_Entry$aiLearning19 = Entry.aiLearning) === null || _Entry$aiLearning19 === void 0 || (_Entry$aiLearning19$g = _Entry$aiLearning19.getTableData) === null || _Entry$aiLearning19$g === void 0 ? void 0 : _Entry$aiLearning19$g.call(_Entry$aiLearning19);
            if (table) {
              var _Entry$aiLearning20, _Entry$aiLearning20$g, _select$1;
              var _Entry$aiLearning$get38 = (_Entry$aiLearning20 = Entry.aiLearning) === null || _Entry$aiLearning20 === void 0 || (_Entry$aiLearning20$g = _Entry$aiLearning20.getTableData) === null || _Entry$aiLearning20$g === void 0 ? void 0 : _Entry$aiLearning20$g.call(_Entry$aiLearning20),
                _Entry$aiLearning$get39 = _Entry$aiLearning$get38.select,
                select = _Entry$aiLearning$get39 === void 0 ? [] : _Entry$aiLearning$get39,
                _Entry$aiLearning$get40 = _Entry$aiLearning$get38.fields,
                fields = _Entry$aiLearning$get40 === void 0 ? [] : _Entry$aiLearning$get40;
              return fields[select === null || select === void 0 || (_select$1 = select[0]) === null || _select$1 === void 0 ? void 0 : _select$1[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning21, _Entry$aiLearning21$g;
            var table = (_Entry$aiLearning21 = Entry.aiLearning) === null || _Entry$aiLearning21 === void 0 || (_Entry$aiLearning21$g = _Entry$aiLearning21.getTableData) === null || _Entry$aiLearning21$g === void 0 ? void 0 : _Entry$aiLearning21$g.call(_Entry$aiLearning21);
            if (table) {
              var _Entry$aiLearning22, _Entry$aiLearning22$g, _select$10;
              var _Entry$aiLearning$get41 = (_Entry$aiLearning22 = Entry.aiLearning) === null || _Entry$aiLearning22 === void 0 || (_Entry$aiLearning22$g = _Entry$aiLearning22.getTableData) === null || _Entry$aiLearning22$g === void 0 ? void 0 : _Entry$aiLearning22$g.call(_Entry$aiLearning22),
                _Entry$aiLearning$get42 = _Entry$aiLearning$get41.select,
                select = _Entry$aiLearning$get42 === void 0 ? [] : _Entry$aiLearning$get42,
                _Entry$aiLearning$get43 = _Entry$aiLearning$get41.fields,
                fields = _Entry$aiLearning$get43 === void 0 ? [] : _Entry$aiLearning$get43;
              return fields[select === null || select === void 0 || (_select$10 = select[0]) === null || _select$10 === void 0 ? void 0 : _select$10[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning23, _Entry$aiLearning23$g;
            var table = (_Entry$aiLearning23 = Entry.aiLearning) === null || _Entry$aiLearning23 === void 0 || (_Entry$aiLearning23$g = _Entry$aiLearning23.getTableData) === null || _Entry$aiLearning23$g === void 0 ? void 0 : _Entry$aiLearning23$g.call(_Entry$aiLearning23);
            if (table) {
              var _Entry$aiLearning24, _Entry$aiLearning24$g, _select$11;
              var _Entry$aiLearning$get44 = (_Entry$aiLearning24 = Entry.aiLearning) === null || _Entry$aiLearning24 === void 0 || (_Entry$aiLearning24$g = _Entry$aiLearning24.getTableData) === null || _Entry$aiLearning24$g === void 0 ? void 0 : _Entry$aiLearning24$g.call(_Entry$aiLearning24),
                _Entry$aiLearning$get45 = _Entry$aiLearning$get44.select,
                select = _Entry$aiLearning$get45 === void 0 ? [] : _Entry$aiLearning$get45,
                _Entry$aiLearning$get46 = _Entry$aiLearning$get44.fields,
                fields = _Entry$aiLearning$get46 === void 0 ? [] : _Entry$aiLearning$get46;
              return fields[select === null || select === void 0 || (_select$11 = select[0]) === null || _select$11 === void 0 ? void 0 : _select$11[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning25, _Entry$aiLearning25$g;
            var table = (_Entry$aiLearning25 = Entry.aiLearning) === null || _Entry$aiLearning25 === void 0 || (_Entry$aiLearning25$g = _Entry$aiLearning25.getTableData) === null || _Entry$aiLearning25$g === void 0 ? void 0 : _Entry$aiLearning25$g.call(_Entry$aiLearning25);
            if (table) {
              var _Entry$aiLearning26, _Entry$aiLearning26$g, _select$12;
              var _Entry$aiLearning$get47 = (_Entry$aiLearning26 = Entry.aiLearning) === null || _Entry$aiLearning26 === void 0 || (_Entry$aiLearning26$g = _Entry$aiLearning26.getTableData) === null || _Entry$aiLearning26$g === void 0 ? void 0 : _Entry$aiLearning26$g.call(_Entry$aiLearning26),
                _Entry$aiLearning$get48 = _Entry$aiLearning$get47.select,
                select = _Entry$aiLearning$get48 === void 0 ? [] : _Entry$aiLearning$get48,
                _Entry$aiLearning$get49 = _Entry$aiLearning$get47.fields,
                fields = _Entry$aiLearning$get49 === void 0 ? [] : _Entry$aiLearning$get49;
              return fields[select === null || select === void 0 || (_select$12 = select[0]) === null || _select$12 === void 0 ? void 0 : _select$12[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning27, _Entry$aiLearning27$g;
            var table = (_Entry$aiLearning27 = Entry.aiLearning) === null || _Entry$aiLearning27 === void 0 || (_Entry$aiLearning27$g = _Entry$aiLearning27.getTableData) === null || _Entry$aiLearning27$g === void 0 ? void 0 : _Entry$aiLearning27$g.call(_Entry$aiLearning27);
            if (table) {
              var _Entry$aiLearning28, _Entry$aiLearning28$g, _select$13;
              var _Entry$aiLearning$get50 = (_Entry$aiLearning28 = Entry.aiLearning) === null || _Entry$aiLearning28 === void 0 || (_Entry$aiLearning28$g = _Entry$aiLearning28.getTableData) === null || _Entry$aiLearning28$g === void 0 ? void 0 : _Entry$aiLearning28$g.call(_Entry$aiLearning28),
                _Entry$aiLearning$get51 = _Entry$aiLearning$get50.select,
                select = _Entry$aiLearning$get51 === void 0 ? [] : _Entry$aiLearning$get51,
                _Entry$aiLearning$get52 = _Entry$aiLearning$get50.fields,
                fields = _Entry$aiLearning$get52 === void 0 ? [] : _Entry$aiLearning$get52;
              return fields[select === null || select === void 0 || (_select$13 = select[0]) === null || _select$13 === void 0 ? void 0 : _select$13[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_5'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_5'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_5'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
            var a, b, c, d, e, _Entry$aiLearning$get53, _Entry$aiLearning$get54, className;
            return _regenerator["default"].wrap(function (_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  _context6.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e]);
                case 1:
                  _Entry$aiLearning$get53 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get54 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get53, 1), className = _Entry$aiLearning$get54[0].className;
                  return _context6.abrupt("return", className);
                case 2:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_6: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning29, _Entry$aiLearning29$g;
            var table = (_Entry$aiLearning29 = Entry.aiLearning) === null || _Entry$aiLearning29 === void 0 || (_Entry$aiLearning29$g = _Entry$aiLearning29.getTableData) === null || _Entry$aiLearning29$g === void 0 ? void 0 : _Entry$aiLearning29$g.call(_Entry$aiLearning29);
            if (table) {
              var _Entry$aiLearning30, _Entry$aiLearning30$g, _select$14;
              var _Entry$aiLearning$get55 = (_Entry$aiLearning30 = Entry.aiLearning) === null || _Entry$aiLearning30 === void 0 || (_Entry$aiLearning30$g = _Entry$aiLearning30.getTableData) === null || _Entry$aiLearning30$g === void 0 ? void 0 : _Entry$aiLearning30$g.call(_Entry$aiLearning30),
                _Entry$aiLearning$get56 = _Entry$aiLearning$get55.select,
                select = _Entry$aiLearning$get56 === void 0 ? [] : _Entry$aiLearning$get56,
                _Entry$aiLearning$get57 = _Entry$aiLearning$get55.fields,
                fields = _Entry$aiLearning$get57 === void 0 ? [] : _Entry$aiLearning$get57;
              return fields[select === null || select === void 0 || (_select$14 = select[0]) === null || _select$14 === void 0 ? void 0 : _select$14[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning31, _Entry$aiLearning31$g;
            var table = (_Entry$aiLearning31 = Entry.aiLearning) === null || _Entry$aiLearning31 === void 0 || (_Entry$aiLearning31$g = _Entry$aiLearning31.getTableData) === null || _Entry$aiLearning31$g === void 0 ? void 0 : _Entry$aiLearning31$g.call(_Entry$aiLearning31);
            if (table) {
              var _Entry$aiLearning32, _Entry$aiLearning32$g, _select$15;
              var _Entry$aiLearning$get58 = (_Entry$aiLearning32 = Entry.aiLearning) === null || _Entry$aiLearning32 === void 0 || (_Entry$aiLearning32$g = _Entry$aiLearning32.getTableData) === null || _Entry$aiLearning32$g === void 0 ? void 0 : _Entry$aiLearning32$g.call(_Entry$aiLearning32),
                _Entry$aiLearning$get59 = _Entry$aiLearning$get58.select,
                select = _Entry$aiLearning$get59 === void 0 ? [] : _Entry$aiLearning$get59,
                _Entry$aiLearning$get60 = _Entry$aiLearning$get58.fields,
                fields = _Entry$aiLearning$get60 === void 0 ? [] : _Entry$aiLearning$get60;
              return fields[select === null || select === void 0 || (_select$15 = select[0]) === null || _select$15 === void 0 ? void 0 : _select$15[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning33, _Entry$aiLearning33$g;
            var table = (_Entry$aiLearning33 = Entry.aiLearning) === null || _Entry$aiLearning33 === void 0 || (_Entry$aiLearning33$g = _Entry$aiLearning33.getTableData) === null || _Entry$aiLearning33$g === void 0 ? void 0 : _Entry$aiLearning33$g.call(_Entry$aiLearning33);
            if (table) {
              var _Entry$aiLearning34, _Entry$aiLearning34$g, _select$16;
              var _Entry$aiLearning$get61 = (_Entry$aiLearning34 = Entry.aiLearning) === null || _Entry$aiLearning34 === void 0 || (_Entry$aiLearning34$g = _Entry$aiLearning34.getTableData) === null || _Entry$aiLearning34$g === void 0 ? void 0 : _Entry$aiLearning34$g.call(_Entry$aiLearning34),
                _Entry$aiLearning$get62 = _Entry$aiLearning$get61.select,
                select = _Entry$aiLearning$get62 === void 0 ? [] : _Entry$aiLearning$get62,
                _Entry$aiLearning$get63 = _Entry$aiLearning$get61.fields,
                fields = _Entry$aiLearning$get63 === void 0 ? [] : _Entry$aiLearning$get63;
              return fields[select === null || select === void 0 || (_select$16 = select[0]) === null || _select$16 === void 0 ? void 0 : _select$16[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning35, _Entry$aiLearning35$g;
            var table = (_Entry$aiLearning35 = Entry.aiLearning) === null || _Entry$aiLearning35 === void 0 || (_Entry$aiLearning35$g = _Entry$aiLearning35.getTableData) === null || _Entry$aiLearning35$g === void 0 ? void 0 : _Entry$aiLearning35$g.call(_Entry$aiLearning35);
            if (table) {
              var _Entry$aiLearning36, _Entry$aiLearning36$g, _select$17;
              var _Entry$aiLearning$get64 = (_Entry$aiLearning36 = Entry.aiLearning) === null || _Entry$aiLearning36 === void 0 || (_Entry$aiLearning36$g = _Entry$aiLearning36.getTableData) === null || _Entry$aiLearning36$g === void 0 ? void 0 : _Entry$aiLearning36$g.call(_Entry$aiLearning36),
                _Entry$aiLearning$get65 = _Entry$aiLearning$get64.select,
                select = _Entry$aiLearning$get65 === void 0 ? [] : _Entry$aiLearning$get65,
                _Entry$aiLearning$get66 = _Entry$aiLearning$get64.fields,
                fields = _Entry$aiLearning$get66 === void 0 ? [] : _Entry$aiLearning$get66;
              return fields[select === null || select === void 0 || (_select$17 = select[0]) === null || _select$17 === void 0 ? void 0 : _select$17[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning37, _Entry$aiLearning37$g;
            var table = (_Entry$aiLearning37 = Entry.aiLearning) === null || _Entry$aiLearning37 === void 0 || (_Entry$aiLearning37$g = _Entry$aiLearning37.getTableData) === null || _Entry$aiLearning37$g === void 0 ? void 0 : _Entry$aiLearning37$g.call(_Entry$aiLearning37);
            if (table) {
              var _Entry$aiLearning38, _Entry$aiLearning38$g, _select$18;
              var _Entry$aiLearning$get67 = (_Entry$aiLearning38 = Entry.aiLearning) === null || _Entry$aiLearning38 === void 0 || (_Entry$aiLearning38$g = _Entry$aiLearning38.getTableData) === null || _Entry$aiLearning38$g === void 0 ? void 0 : _Entry$aiLearning38$g.call(_Entry$aiLearning38),
                _Entry$aiLearning$get68 = _Entry$aiLearning$get67.select,
                select = _Entry$aiLearning$get68 === void 0 ? [] : _Entry$aiLearning$get68,
                _Entry$aiLearning$get69 = _Entry$aiLearning$get67.fields,
                fields = _Entry$aiLearning$get69 === void 0 ? [] : _Entry$aiLearning$get69;
              return fields[select === null || select === void 0 || (_select$18 = select[0]) === null || _select$18 === void 0 ? void 0 : _select$18[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning39, _Entry$aiLearning39$g;
            var table = (_Entry$aiLearning39 = Entry.aiLearning) === null || _Entry$aiLearning39 === void 0 || (_Entry$aiLearning39$g = _Entry$aiLearning39.getTableData) === null || _Entry$aiLearning39$g === void 0 ? void 0 : _Entry$aiLearning39$g.call(_Entry$aiLearning39);
            if (table) {
              var _Entry$aiLearning40, _Entry$aiLearning40$g, _select$19;
              var _Entry$aiLearning$get70 = (_Entry$aiLearning40 = Entry.aiLearning) === null || _Entry$aiLearning40 === void 0 || (_Entry$aiLearning40$g = _Entry$aiLearning40.getTableData) === null || _Entry$aiLearning40$g === void 0 ? void 0 : _Entry$aiLearning40$g.call(_Entry$aiLearning40),
                _Entry$aiLearning$get71 = _Entry$aiLearning$get70.select,
                select = _Entry$aiLearning$get71 === void 0 ? [] : _Entry$aiLearning$get71,
                _Entry$aiLearning$get72 = _Entry$aiLearning$get70.fields,
                fields = _Entry$aiLearning$get72 === void 0 ? [] : _Entry$aiLearning$get72;
              return fields[select === null || select === void 0 || (_select$19 = select[0]) === null || _select$19 === void 0 ? void 0 : _select$19[5]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_6'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_6'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9,
          ATTR6: 11
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_6'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
            var a, b, c, d, e, f, _Entry$aiLearning$get73, _Entry$aiLearning$get74, className;
            return _regenerator["default"].wrap(function (_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  f = script.getNumberValue('ATTR6', script);
                  _context7.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e, f]);
                case 1:
                  _Entry$aiLearning$get73 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get74 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get73, 1), className = _Entry$aiLearning$get74[0].className;
                  return _context7.abrupt("return", className);
                case 2:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_param_1: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning41, _Entry$aiLearning41$g;
            var table = (_Entry$aiLearning41 = Entry.aiLearning) === null || _Entry$aiLearning41 === void 0 || (_Entry$aiLearning41$g = _Entry$aiLearning41.getTableData) === null || _Entry$aiLearning41$g === void 0 ? void 0 : _Entry$aiLearning41$g.call(_Entry$aiLearning41);
            if (table) {
              var _Entry$aiLearning42, _Entry$aiLearning42$g, _select$20;
              var _Entry$aiLearning$get75 = (_Entry$aiLearning42 = Entry.aiLearning) === null || _Entry$aiLearning42 === void 0 || (_Entry$aiLearning42$g = _Entry$aiLearning42.getTableData) === null || _Entry$aiLearning42$g === void 0 ? void 0 : _Entry$aiLearning42$g.call(_Entry$aiLearning42),
                _Entry$aiLearning$get76 = _Entry$aiLearning$get75.select,
                select = _Entry$aiLearning$get76 === void 0 ? [] : _Entry$aiLearning$get76,
                _Entry$aiLearning$get77 = _Entry$aiLearning$get75.fields,
                fields = _Entry$aiLearning$get77 === void 0 ? [] : _Entry$aiLearning$get77;
              return fields[select === null || select === void 0 || (_select$20 = select[0]) === null || _select$20 === void 0 ? void 0 : _select$20[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }, {
          type: 'Dropdown',
          options: [
          // [Lang.AiLearning.probability, 'probability'],
          [Lang.AiLearning.neighbor_count, 'count']],
          value: 'count',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_param_1'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_param_1'
        },
        paramsKeyMap: {
          ATTR1: 1,
          CLASS: 2,
          OPTION: 3
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_1'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8() {
            var x, clazz, option, result, classData;
            return _regenerator["default"].wrap(function (_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  clazz = script.getField('CLASS', script);
                  option = script.getField('OPTION', script);
                  _context8.next = 1;
                  return Entry.aiLearning.predict([x]);
                case 1:
                  result = Entry.aiLearning.getPredictResult();
                  classData = result.find(function (_ref) {
                    var className = _ref.className;
                    return className === clazz;
                  }) || {};
                  return _context8.abrupt("return", classData[option] || 0);
                case 2:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_param_2: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning43, _Entry$aiLearning43$g;
            var table = (_Entry$aiLearning43 = Entry.aiLearning) === null || _Entry$aiLearning43 === void 0 || (_Entry$aiLearning43$g = _Entry$aiLearning43.getTableData) === null || _Entry$aiLearning43$g === void 0 ? void 0 : _Entry$aiLearning43$g.call(_Entry$aiLearning43);
            if (table) {
              var _Entry$aiLearning44, _Entry$aiLearning44$g, _select$21;
              var _Entry$aiLearning$get78 = (_Entry$aiLearning44 = Entry.aiLearning) === null || _Entry$aiLearning44 === void 0 || (_Entry$aiLearning44$g = _Entry$aiLearning44.getTableData) === null || _Entry$aiLearning44$g === void 0 ? void 0 : _Entry$aiLearning44$g.call(_Entry$aiLearning44),
                _Entry$aiLearning$get79 = _Entry$aiLearning$get78.select,
                select = _Entry$aiLearning$get79 === void 0 ? [] : _Entry$aiLearning$get79,
                _Entry$aiLearning$get80 = _Entry$aiLearning$get78.fields,
                fields = _Entry$aiLearning$get80 === void 0 ? [] : _Entry$aiLearning$get80;
              return fields[select === null || select === void 0 || (_select$21 = select[0]) === null || _select$21 === void 0 ? void 0 : _select$21[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning45, _Entry$aiLearning45$g;
            var table = (_Entry$aiLearning45 = Entry.aiLearning) === null || _Entry$aiLearning45 === void 0 || (_Entry$aiLearning45$g = _Entry$aiLearning45.getTableData) === null || _Entry$aiLearning45$g === void 0 ? void 0 : _Entry$aiLearning45$g.call(_Entry$aiLearning45);
            if (table) {
              var _Entry$aiLearning46, _Entry$aiLearning46$g, _select$22;
              var _Entry$aiLearning$get81 = (_Entry$aiLearning46 = Entry.aiLearning) === null || _Entry$aiLearning46 === void 0 || (_Entry$aiLearning46$g = _Entry$aiLearning46.getTableData) === null || _Entry$aiLearning46$g === void 0 ? void 0 : _Entry$aiLearning46$g.call(_Entry$aiLearning46),
                _Entry$aiLearning$get82 = _Entry$aiLearning$get81.select,
                select = _Entry$aiLearning$get82 === void 0 ? [] : _Entry$aiLearning$get82,
                _Entry$aiLearning$get83 = _Entry$aiLearning$get81.fields,
                fields = _Entry$aiLearning$get83 === void 0 ? [] : _Entry$aiLearning$get83;
              return fields[select === null || select === void 0 || (_select$22 = select[0]) === null || _select$22 === void 0 ? void 0 : _select$22[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }, {
          type: 'Dropdown',
          options: [
          // [Lang.AiLearning.probability, 'probability'],
          [Lang.AiLearning.neighbor_count, 'count']],
          value: 'count',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_param_2'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_param_2'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          CLASS: 4,
          OPTION: 5
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_2'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9() {
            var x, y, clazz, option, result, classData;
            return _regenerator["default"].wrap(function (_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  clazz = script.getField('CLASS', script);
                  option = script.getField('OPTION', script);
                  _context9.next = 1;
                  return Entry.aiLearning.predict([x, y]);
                case 1:
                  result = Entry.aiLearning.getPredictResult();
                  classData = result.find(function (_ref2) {
                    var className = _ref2.className;
                    return className === clazz;
                  }) || {};
                  return _context9.abrupt("return", classData[option] || 0);
                case 2:
                case "end":
                  return _context9.stop();
              }
            }, _callee9);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_param_3: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning47, _Entry$aiLearning47$g;
            var table = (_Entry$aiLearning47 = Entry.aiLearning) === null || _Entry$aiLearning47 === void 0 || (_Entry$aiLearning47$g = _Entry$aiLearning47.getTableData) === null || _Entry$aiLearning47$g === void 0 ? void 0 : _Entry$aiLearning47$g.call(_Entry$aiLearning47);
            if (table) {
              var _Entry$aiLearning48, _Entry$aiLearning48$g, _select$23;
              var _Entry$aiLearning$get84 = (_Entry$aiLearning48 = Entry.aiLearning) === null || _Entry$aiLearning48 === void 0 || (_Entry$aiLearning48$g = _Entry$aiLearning48.getTableData) === null || _Entry$aiLearning48$g === void 0 ? void 0 : _Entry$aiLearning48$g.call(_Entry$aiLearning48),
                _Entry$aiLearning$get85 = _Entry$aiLearning$get84.select,
                select = _Entry$aiLearning$get85 === void 0 ? [] : _Entry$aiLearning$get85,
                _Entry$aiLearning$get86 = _Entry$aiLearning$get84.fields,
                fields = _Entry$aiLearning$get86 === void 0 ? [] : _Entry$aiLearning$get86;
              return fields[select === null || select === void 0 || (_select$23 = select[0]) === null || _select$23 === void 0 ? void 0 : _select$23[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning49, _Entry$aiLearning49$g;
            var table = (_Entry$aiLearning49 = Entry.aiLearning) === null || _Entry$aiLearning49 === void 0 || (_Entry$aiLearning49$g = _Entry$aiLearning49.getTableData) === null || _Entry$aiLearning49$g === void 0 ? void 0 : _Entry$aiLearning49$g.call(_Entry$aiLearning49);
            if (table) {
              var _Entry$aiLearning50, _Entry$aiLearning50$g, _select$24;
              var _Entry$aiLearning$get87 = (_Entry$aiLearning50 = Entry.aiLearning) === null || _Entry$aiLearning50 === void 0 || (_Entry$aiLearning50$g = _Entry$aiLearning50.getTableData) === null || _Entry$aiLearning50$g === void 0 ? void 0 : _Entry$aiLearning50$g.call(_Entry$aiLearning50),
                _Entry$aiLearning$get88 = _Entry$aiLearning$get87.select,
                select = _Entry$aiLearning$get88 === void 0 ? [] : _Entry$aiLearning$get88,
                _Entry$aiLearning$get89 = _Entry$aiLearning$get87.fields,
                fields = _Entry$aiLearning$get89 === void 0 ? [] : _Entry$aiLearning$get89;
              return fields[select === null || select === void 0 || (_select$24 = select[0]) === null || _select$24 === void 0 ? void 0 : _select$24[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning51, _Entry$aiLearning51$g;
            var table = (_Entry$aiLearning51 = Entry.aiLearning) === null || _Entry$aiLearning51 === void 0 || (_Entry$aiLearning51$g = _Entry$aiLearning51.getTableData) === null || _Entry$aiLearning51$g === void 0 ? void 0 : _Entry$aiLearning51$g.call(_Entry$aiLearning51);
            if (table) {
              var _Entry$aiLearning52, _Entry$aiLearning52$g, _select$25;
              var _Entry$aiLearning$get90 = (_Entry$aiLearning52 = Entry.aiLearning) === null || _Entry$aiLearning52 === void 0 || (_Entry$aiLearning52$g = _Entry$aiLearning52.getTableData) === null || _Entry$aiLearning52$g === void 0 ? void 0 : _Entry$aiLearning52$g.call(_Entry$aiLearning52),
                _Entry$aiLearning$get91 = _Entry$aiLearning$get90.select,
                select = _Entry$aiLearning$get91 === void 0 ? [] : _Entry$aiLearning$get91,
                _Entry$aiLearning$get92 = _Entry$aiLearning$get90.fields,
                fields = _Entry$aiLearning$get92 === void 0 ? [] : _Entry$aiLearning$get92;
              return fields[select === null || select === void 0 || (_select$25 = select[0]) === null || _select$25 === void 0 ? void 0 : _select$25[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }, {
          type: 'Dropdown',
          options: [
          // [Lang.AiLearning.probability, 'probability'],
          [Lang.AiLearning.neighbor_count, 'count']],
          value: 'count',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_param_3'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_param_3'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          CLASS: 6,
          OPTION: 7
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_3'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
            var x, y, z, clazz, option, result, classData;
            return _regenerator["default"].wrap(function (_context0) {
              while (1) switch (_context0.prev = _context0.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  z = script.getNumberValue('ATTR3', script);
                  clazz = script.getField('CLASS', script);
                  option = script.getField('OPTION', script);
                  _context0.next = 1;
                  return Entry.aiLearning.predict([x, y, z]);
                case 1:
                  result = Entry.aiLearning.getPredictResult();
                  classData = result.find(function (_ref3) {
                    var className = _ref3.className;
                    return className === clazz;
                  }) || {};
                  return _context0.abrupt("return", classData[option] || 0);
                case 2:
                case "end":
                  return _context0.stop();
              }
            }, _callee0);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_param_4: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning53, _Entry$aiLearning53$g;
            var table = (_Entry$aiLearning53 = Entry.aiLearning) === null || _Entry$aiLearning53 === void 0 || (_Entry$aiLearning53$g = _Entry$aiLearning53.getTableData) === null || _Entry$aiLearning53$g === void 0 ? void 0 : _Entry$aiLearning53$g.call(_Entry$aiLearning53);
            if (table) {
              var _Entry$aiLearning54, _Entry$aiLearning54$g, _select$26;
              var _Entry$aiLearning$get93 = (_Entry$aiLearning54 = Entry.aiLearning) === null || _Entry$aiLearning54 === void 0 || (_Entry$aiLearning54$g = _Entry$aiLearning54.getTableData) === null || _Entry$aiLearning54$g === void 0 ? void 0 : _Entry$aiLearning54$g.call(_Entry$aiLearning54),
                _Entry$aiLearning$get94 = _Entry$aiLearning$get93.select,
                select = _Entry$aiLearning$get94 === void 0 ? [] : _Entry$aiLearning$get94,
                _Entry$aiLearning$get95 = _Entry$aiLearning$get93.fields,
                fields = _Entry$aiLearning$get95 === void 0 ? [] : _Entry$aiLearning$get95;
              return fields[select === null || select === void 0 || (_select$26 = select[0]) === null || _select$26 === void 0 ? void 0 : _select$26[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning55, _Entry$aiLearning55$g;
            var table = (_Entry$aiLearning55 = Entry.aiLearning) === null || _Entry$aiLearning55 === void 0 || (_Entry$aiLearning55$g = _Entry$aiLearning55.getTableData) === null || _Entry$aiLearning55$g === void 0 ? void 0 : _Entry$aiLearning55$g.call(_Entry$aiLearning55);
            if (table) {
              var _Entry$aiLearning56, _Entry$aiLearning56$g, _select$27;
              var _Entry$aiLearning$get96 = (_Entry$aiLearning56 = Entry.aiLearning) === null || _Entry$aiLearning56 === void 0 || (_Entry$aiLearning56$g = _Entry$aiLearning56.getTableData) === null || _Entry$aiLearning56$g === void 0 ? void 0 : _Entry$aiLearning56$g.call(_Entry$aiLearning56),
                _Entry$aiLearning$get97 = _Entry$aiLearning$get96.select,
                select = _Entry$aiLearning$get97 === void 0 ? [] : _Entry$aiLearning$get97,
                _Entry$aiLearning$get98 = _Entry$aiLearning$get96.fields,
                fields = _Entry$aiLearning$get98 === void 0 ? [] : _Entry$aiLearning$get98;
              return fields[select === null || select === void 0 || (_select$27 = select[0]) === null || _select$27 === void 0 ? void 0 : _select$27[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning57, _Entry$aiLearning57$g;
            var table = (_Entry$aiLearning57 = Entry.aiLearning) === null || _Entry$aiLearning57 === void 0 || (_Entry$aiLearning57$g = _Entry$aiLearning57.getTableData) === null || _Entry$aiLearning57$g === void 0 ? void 0 : _Entry$aiLearning57$g.call(_Entry$aiLearning57);
            if (table) {
              var _Entry$aiLearning58, _Entry$aiLearning58$g, _select$28;
              var _Entry$aiLearning$get99 = (_Entry$aiLearning58 = Entry.aiLearning) === null || _Entry$aiLearning58 === void 0 || (_Entry$aiLearning58$g = _Entry$aiLearning58.getTableData) === null || _Entry$aiLearning58$g === void 0 ? void 0 : _Entry$aiLearning58$g.call(_Entry$aiLearning58),
                _Entry$aiLearning$get100 = _Entry$aiLearning$get99.select,
                select = _Entry$aiLearning$get100 === void 0 ? [] : _Entry$aiLearning$get100,
                _Entry$aiLearning$get101 = _Entry$aiLearning$get99.fields,
                fields = _Entry$aiLearning$get101 === void 0 ? [] : _Entry$aiLearning$get101;
              return fields[select === null || select === void 0 || (_select$28 = select[0]) === null || _select$28 === void 0 ? void 0 : _select$28[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning59, _Entry$aiLearning59$g;
            var table = (_Entry$aiLearning59 = Entry.aiLearning) === null || _Entry$aiLearning59 === void 0 || (_Entry$aiLearning59$g = _Entry$aiLearning59.getTableData) === null || _Entry$aiLearning59$g === void 0 ? void 0 : _Entry$aiLearning59$g.call(_Entry$aiLearning59);
            if (table) {
              var _Entry$aiLearning60, _Entry$aiLearning60$g, _select$29;
              var _Entry$aiLearning$get102 = (_Entry$aiLearning60 = Entry.aiLearning) === null || _Entry$aiLearning60 === void 0 || (_Entry$aiLearning60$g = _Entry$aiLearning60.getTableData) === null || _Entry$aiLearning60$g === void 0 ? void 0 : _Entry$aiLearning60$g.call(_Entry$aiLearning60),
                _Entry$aiLearning$get103 = _Entry$aiLearning$get102.select,
                select = _Entry$aiLearning$get103 === void 0 ? [] : _Entry$aiLearning$get103,
                _Entry$aiLearning$get104 = _Entry$aiLearning$get102.fields,
                fields = _Entry$aiLearning$get104 === void 0 ? [] : _Entry$aiLearning$get104;
              return fields[select === null || select === void 0 || (_select$29 = select[0]) === null || _select$29 === void 0 ? void 0 : _select$29[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }, {
          type: 'Dropdown',
          options: [
          // [Lang.AiLearning.probability, 'probability'],
          [Lang.AiLearning.neighbor_count, 'count']],
          value: 'count',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_param_4'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_param_4'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          CLASS: 8,
          OPTION: 9
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_4'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1() {
            var a, b, c, d, clazz, option, result, classData;
            return _regenerator["default"].wrap(function (_context1) {
              while (1) switch (_context1.prev = _context1.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  clazz = script.getField('CLASS', script);
                  option = script.getField('OPTION', script);
                  _context1.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d]);
                case 1:
                  result = Entry.aiLearning.getPredictResult();
                  classData = result.find(function (_ref4) {
                    var className = _ref4.className;
                    return className === clazz;
                  }) || {};
                  return _context1.abrupt("return", classData[option] || 0);
                case 2:
                case "end":
                  return _context1.stop();
              }
            }, _callee1);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_param_5: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning61, _Entry$aiLearning61$g;
            var table = (_Entry$aiLearning61 = Entry.aiLearning) === null || _Entry$aiLearning61 === void 0 || (_Entry$aiLearning61$g = _Entry$aiLearning61.getTableData) === null || _Entry$aiLearning61$g === void 0 ? void 0 : _Entry$aiLearning61$g.call(_Entry$aiLearning61);
            if (table) {
              var _Entry$aiLearning62, _Entry$aiLearning62$g, _select$30;
              var _Entry$aiLearning$get105 = (_Entry$aiLearning62 = Entry.aiLearning) === null || _Entry$aiLearning62 === void 0 || (_Entry$aiLearning62$g = _Entry$aiLearning62.getTableData) === null || _Entry$aiLearning62$g === void 0 ? void 0 : _Entry$aiLearning62$g.call(_Entry$aiLearning62),
                _Entry$aiLearning$get106 = _Entry$aiLearning$get105.select,
                select = _Entry$aiLearning$get106 === void 0 ? [] : _Entry$aiLearning$get106,
                _Entry$aiLearning$get107 = _Entry$aiLearning$get105.fields,
                fields = _Entry$aiLearning$get107 === void 0 ? [] : _Entry$aiLearning$get107;
              return fields[select === null || select === void 0 || (_select$30 = select[0]) === null || _select$30 === void 0 ? void 0 : _select$30[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning63, _Entry$aiLearning63$g;
            var table = (_Entry$aiLearning63 = Entry.aiLearning) === null || _Entry$aiLearning63 === void 0 || (_Entry$aiLearning63$g = _Entry$aiLearning63.getTableData) === null || _Entry$aiLearning63$g === void 0 ? void 0 : _Entry$aiLearning63$g.call(_Entry$aiLearning63);
            if (table) {
              var _Entry$aiLearning64, _Entry$aiLearning64$g, _select$31;
              var _Entry$aiLearning$get108 = (_Entry$aiLearning64 = Entry.aiLearning) === null || _Entry$aiLearning64 === void 0 || (_Entry$aiLearning64$g = _Entry$aiLearning64.getTableData) === null || _Entry$aiLearning64$g === void 0 ? void 0 : _Entry$aiLearning64$g.call(_Entry$aiLearning64),
                _Entry$aiLearning$get109 = _Entry$aiLearning$get108.select,
                select = _Entry$aiLearning$get109 === void 0 ? [] : _Entry$aiLearning$get109,
                _Entry$aiLearning$get110 = _Entry$aiLearning$get108.fields,
                fields = _Entry$aiLearning$get110 === void 0 ? [] : _Entry$aiLearning$get110;
              return fields[select === null || select === void 0 || (_select$31 = select[0]) === null || _select$31 === void 0 ? void 0 : _select$31[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning65, _Entry$aiLearning65$g;
            var table = (_Entry$aiLearning65 = Entry.aiLearning) === null || _Entry$aiLearning65 === void 0 || (_Entry$aiLearning65$g = _Entry$aiLearning65.getTableData) === null || _Entry$aiLearning65$g === void 0 ? void 0 : _Entry$aiLearning65$g.call(_Entry$aiLearning65);
            if (table) {
              var _Entry$aiLearning66, _Entry$aiLearning66$g, _select$32;
              var _Entry$aiLearning$get111 = (_Entry$aiLearning66 = Entry.aiLearning) === null || _Entry$aiLearning66 === void 0 || (_Entry$aiLearning66$g = _Entry$aiLearning66.getTableData) === null || _Entry$aiLearning66$g === void 0 ? void 0 : _Entry$aiLearning66$g.call(_Entry$aiLearning66),
                _Entry$aiLearning$get112 = _Entry$aiLearning$get111.select,
                select = _Entry$aiLearning$get112 === void 0 ? [] : _Entry$aiLearning$get112,
                _Entry$aiLearning$get113 = _Entry$aiLearning$get111.fields,
                fields = _Entry$aiLearning$get113 === void 0 ? [] : _Entry$aiLearning$get113;
              return fields[select === null || select === void 0 || (_select$32 = select[0]) === null || _select$32 === void 0 ? void 0 : _select$32[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning67, _Entry$aiLearning67$g;
            var table = (_Entry$aiLearning67 = Entry.aiLearning) === null || _Entry$aiLearning67 === void 0 || (_Entry$aiLearning67$g = _Entry$aiLearning67.getTableData) === null || _Entry$aiLearning67$g === void 0 ? void 0 : _Entry$aiLearning67$g.call(_Entry$aiLearning67);
            if (table) {
              var _Entry$aiLearning68, _Entry$aiLearning68$g, _select$33;
              var _Entry$aiLearning$get114 = (_Entry$aiLearning68 = Entry.aiLearning) === null || _Entry$aiLearning68 === void 0 || (_Entry$aiLearning68$g = _Entry$aiLearning68.getTableData) === null || _Entry$aiLearning68$g === void 0 ? void 0 : _Entry$aiLearning68$g.call(_Entry$aiLearning68),
                _Entry$aiLearning$get115 = _Entry$aiLearning$get114.select,
                select = _Entry$aiLearning$get115 === void 0 ? [] : _Entry$aiLearning$get115,
                _Entry$aiLearning$get116 = _Entry$aiLearning$get114.fields,
                fields = _Entry$aiLearning$get116 === void 0 ? [] : _Entry$aiLearning$get116;
              return fields[select === null || select === void 0 || (_select$33 = select[0]) === null || _select$33 === void 0 ? void 0 : _select$33[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning69, _Entry$aiLearning69$g;
            var table = (_Entry$aiLearning69 = Entry.aiLearning) === null || _Entry$aiLearning69 === void 0 || (_Entry$aiLearning69$g = _Entry$aiLearning69.getTableData) === null || _Entry$aiLearning69$g === void 0 ? void 0 : _Entry$aiLearning69$g.call(_Entry$aiLearning69);
            if (table) {
              var _Entry$aiLearning70, _Entry$aiLearning70$g, _select$34;
              var _Entry$aiLearning$get117 = (_Entry$aiLearning70 = Entry.aiLearning) === null || _Entry$aiLearning70 === void 0 || (_Entry$aiLearning70$g = _Entry$aiLearning70.getTableData) === null || _Entry$aiLearning70$g === void 0 ? void 0 : _Entry$aiLearning70$g.call(_Entry$aiLearning70),
                _Entry$aiLearning$get118 = _Entry$aiLearning$get117.select,
                select = _Entry$aiLearning$get118 === void 0 ? [] : _Entry$aiLearning$get118,
                _Entry$aiLearning$get119 = _Entry$aiLearning$get117.fields,
                fields = _Entry$aiLearning$get119 === void 0 ? [] : _Entry$aiLearning$get119;
              return fields[select === null || select === void 0 || (_select$34 = select[0]) === null || _select$34 === void 0 ? void 0 : _select$34[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }, {
          type: 'Dropdown',
          options: [
          // [Lang.AiLearning.probability, 'probability'],
          [Lang.AiLearning.neighbor_count, 'count']],
          value: 'count',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_param_5'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_param_5'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9,
          CLASS: 10,
          OPTION: 11
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_5'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10() {
            var a, b, c, d, e, clazz, option, result, classData;
            return _regenerator["default"].wrap(function (_context10) {
              while (1) switch (_context10.prev = _context10.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  clazz = script.getField('CLASS', script);
                  option = script.getField('OPTION', script);
                  _context10.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e]);
                case 1:
                  result = Entry.aiLearning.getPredictResult();
                  classData = result.find(function (_ref5) {
                    var className = _ref5.className;
                    return className === clazz;
                  }) || {};
                  return _context10.abrupt("return", classData[option] || 0);
                case 2:
                case "end":
                  return _context10.stop();
              }
            }, _callee10);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_number_learning_predict_param_6: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning71, _Entry$aiLearning71$g;
            var table = (_Entry$aiLearning71 = Entry.aiLearning) === null || _Entry$aiLearning71 === void 0 || (_Entry$aiLearning71$g = _Entry$aiLearning71.getTableData) === null || _Entry$aiLearning71$g === void 0 ? void 0 : _Entry$aiLearning71$g.call(_Entry$aiLearning71);
            if (table) {
              var _Entry$aiLearning72, _Entry$aiLearning72$g, _select$35;
              var _Entry$aiLearning$get120 = (_Entry$aiLearning72 = Entry.aiLearning) === null || _Entry$aiLearning72 === void 0 || (_Entry$aiLearning72$g = _Entry$aiLearning72.getTableData) === null || _Entry$aiLearning72$g === void 0 ? void 0 : _Entry$aiLearning72$g.call(_Entry$aiLearning72),
                _Entry$aiLearning$get121 = _Entry$aiLearning$get120.select,
                select = _Entry$aiLearning$get121 === void 0 ? [] : _Entry$aiLearning$get121,
                _Entry$aiLearning$get122 = _Entry$aiLearning$get120.fields,
                fields = _Entry$aiLearning$get122 === void 0 ? [] : _Entry$aiLearning$get122;
              return fields[select === null || select === void 0 || (_select$35 = select[0]) === null || _select$35 === void 0 ? void 0 : _select$35[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning73, _Entry$aiLearning73$g;
            var table = (_Entry$aiLearning73 = Entry.aiLearning) === null || _Entry$aiLearning73 === void 0 || (_Entry$aiLearning73$g = _Entry$aiLearning73.getTableData) === null || _Entry$aiLearning73$g === void 0 ? void 0 : _Entry$aiLearning73$g.call(_Entry$aiLearning73);
            if (table) {
              var _Entry$aiLearning74, _Entry$aiLearning74$g, _select$36;
              var _Entry$aiLearning$get123 = (_Entry$aiLearning74 = Entry.aiLearning) === null || _Entry$aiLearning74 === void 0 || (_Entry$aiLearning74$g = _Entry$aiLearning74.getTableData) === null || _Entry$aiLearning74$g === void 0 ? void 0 : _Entry$aiLearning74$g.call(_Entry$aiLearning74),
                _Entry$aiLearning$get124 = _Entry$aiLearning$get123.select,
                select = _Entry$aiLearning$get124 === void 0 ? [] : _Entry$aiLearning$get124,
                _Entry$aiLearning$get125 = _Entry$aiLearning$get123.fields,
                fields = _Entry$aiLearning$get125 === void 0 ? [] : _Entry$aiLearning$get125;
              return fields[select === null || select === void 0 || (_select$36 = select[0]) === null || _select$36 === void 0 ? void 0 : _select$36[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning75, _Entry$aiLearning75$g;
            var table = (_Entry$aiLearning75 = Entry.aiLearning) === null || _Entry$aiLearning75 === void 0 || (_Entry$aiLearning75$g = _Entry$aiLearning75.getTableData) === null || _Entry$aiLearning75$g === void 0 ? void 0 : _Entry$aiLearning75$g.call(_Entry$aiLearning75);
            if (table) {
              var _Entry$aiLearning76, _Entry$aiLearning76$g, _select$37;
              var _Entry$aiLearning$get126 = (_Entry$aiLearning76 = Entry.aiLearning) === null || _Entry$aiLearning76 === void 0 || (_Entry$aiLearning76$g = _Entry$aiLearning76.getTableData) === null || _Entry$aiLearning76$g === void 0 ? void 0 : _Entry$aiLearning76$g.call(_Entry$aiLearning76),
                _Entry$aiLearning$get127 = _Entry$aiLearning$get126.select,
                select = _Entry$aiLearning$get127 === void 0 ? [] : _Entry$aiLearning$get127,
                _Entry$aiLearning$get128 = _Entry$aiLearning$get126.fields,
                fields = _Entry$aiLearning$get128 === void 0 ? [] : _Entry$aiLearning$get128;
              return fields[select === null || select === void 0 || (_select$37 = select[0]) === null || _select$37 === void 0 ? void 0 : _select$37[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning77, _Entry$aiLearning77$g;
            var table = (_Entry$aiLearning77 = Entry.aiLearning) === null || _Entry$aiLearning77 === void 0 || (_Entry$aiLearning77$g = _Entry$aiLearning77.getTableData) === null || _Entry$aiLearning77$g === void 0 ? void 0 : _Entry$aiLearning77$g.call(_Entry$aiLearning77);
            if (table) {
              var _Entry$aiLearning78, _Entry$aiLearning78$g, _select$38;
              var _Entry$aiLearning$get129 = (_Entry$aiLearning78 = Entry.aiLearning) === null || _Entry$aiLearning78 === void 0 || (_Entry$aiLearning78$g = _Entry$aiLearning78.getTableData) === null || _Entry$aiLearning78$g === void 0 ? void 0 : _Entry$aiLearning78$g.call(_Entry$aiLearning78),
                _Entry$aiLearning$get130 = _Entry$aiLearning$get129.select,
                select = _Entry$aiLearning$get130 === void 0 ? [] : _Entry$aiLearning$get130,
                _Entry$aiLearning$get131 = _Entry$aiLearning$get129.fields,
                fields = _Entry$aiLearning$get131 === void 0 ? [] : _Entry$aiLearning$get131;
              return fields[select === null || select === void 0 || (_select$38 = select[0]) === null || _select$38 === void 0 ? void 0 : _select$38[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning79, _Entry$aiLearning79$g;
            var table = (_Entry$aiLearning79 = Entry.aiLearning) === null || _Entry$aiLearning79 === void 0 || (_Entry$aiLearning79$g = _Entry$aiLearning79.getTableData) === null || _Entry$aiLearning79$g === void 0 ? void 0 : _Entry$aiLearning79$g.call(_Entry$aiLearning79);
            if (table) {
              var _Entry$aiLearning80, _Entry$aiLearning80$g, _select$39;
              var _Entry$aiLearning$get132 = (_Entry$aiLearning80 = Entry.aiLearning) === null || _Entry$aiLearning80 === void 0 || (_Entry$aiLearning80$g = _Entry$aiLearning80.getTableData) === null || _Entry$aiLearning80$g === void 0 ? void 0 : _Entry$aiLearning80$g.call(_Entry$aiLearning80),
                _Entry$aiLearning$get133 = _Entry$aiLearning$get132.select,
                select = _Entry$aiLearning$get133 === void 0 ? [] : _Entry$aiLearning$get133,
                _Entry$aiLearning$get134 = _Entry$aiLearning$get132.fields,
                fields = _Entry$aiLearning$get134 === void 0 ? [] : _Entry$aiLearning$get134;
              return fields[select === null || select === void 0 || (_select$39 = select[0]) === null || _select$39 === void 0 ? void 0 : _select$39[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning81, _Entry$aiLearning81$g;
            var table = (_Entry$aiLearning81 = Entry.aiLearning) === null || _Entry$aiLearning81 === void 0 || (_Entry$aiLearning81$g = _Entry$aiLearning81.getTableData) === null || _Entry$aiLearning81$g === void 0 ? void 0 : _Entry$aiLearning81$g.call(_Entry$aiLearning81);
            if (table) {
              var _Entry$aiLearning82, _Entry$aiLearning82$g, _select$40;
              var _Entry$aiLearning$get135 = (_Entry$aiLearning82 = Entry.aiLearning) === null || _Entry$aiLearning82 === void 0 || (_Entry$aiLearning82$g = _Entry$aiLearning82.getTableData) === null || _Entry$aiLearning82$g === void 0 ? void 0 : _Entry$aiLearning82$g.call(_Entry$aiLearning82),
                _Entry$aiLearning$get136 = _Entry$aiLearning$get135.select,
                select = _Entry$aiLearning$get136 === void 0 ? [] : _Entry$aiLearning$get136,
                _Entry$aiLearning$get137 = _Entry$aiLearning$get135.fields,
                fields = _Entry$aiLearning$get137 === void 0 ? [] : _Entry$aiLearning$get137;
              return fields[select === null || select === void 0 || (_select$40 = select[0]) === null || _select$40 === void 0 ? void 0 : _select$40[5]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }, {
          type: 'Dropdown',
          options: [
          // [Lang.AiLearning.probability, 'probability'],
          [Lang.AiLearning.neighbor_count, 'count']],
          value: 'count',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_number_learning_predict_param_6'
        },
        pyHelpDef: {
          params: [],
          type: 'get_number_learning_predict_param_6'
        },
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9,
          ATTR6: 11,
          CLASS: 12,
          OPTION: 13
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_6'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11() {
            var a, b, c, d, e, f, clazz, option, result, classData;
            return _regenerator["default"].wrap(function (_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  f = script.getNumberValue('ATTR6', script);
                  clazz = script.getField('CLASS', script);
                  option = script.getField('OPTION', script);
                  _context11.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e, f]);
                case 1:
                  result = Entry.aiLearning.getPredictResult();
                  classData = result.find(function (_ref6) {
                    var className = _ref6.className;
                    return className === clazz;
                  }) || {};
                  return _context11.abrupt("return", classData[option] || 0);
                case 2:
                case "end":
                  return _context11.stop();
              }
            }, _callee11);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_number_learning_group_1: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning83, _Entry$aiLearning83$g;
            var table = (_Entry$aiLearning83 = Entry.aiLearning) === null || _Entry$aiLearning83 === void 0 || (_Entry$aiLearning83$g = _Entry$aiLearning83.getTableData) === null || _Entry$aiLearning83$g === void 0 ? void 0 : _Entry$aiLearning83$g.call(_Entry$aiLearning83);
            if (table) {
              var _Entry$aiLearning84, _Entry$aiLearning84$g, _select$41;
              var _Entry$aiLearning$get138 = (_Entry$aiLearning84 = Entry.aiLearning) === null || _Entry$aiLearning84 === void 0 || (_Entry$aiLearning84$g = _Entry$aiLearning84.getTableData) === null || _Entry$aiLearning84$g === void 0 ? void 0 : _Entry$aiLearning84$g.call(_Entry$aiLearning84),
                _Entry$aiLearning$get139 = _Entry$aiLearning$get138.select,
                select = _Entry$aiLearning$get139 === void 0 ? [] : _Entry$aiLearning$get139,
                _Entry$aiLearning$get140 = _Entry$aiLearning$get138.fields,
                fields = _Entry$aiLearning$get140 === void 0 ? [] : _Entry$aiLearning$get140;
              return fields[select === null || select === void 0 || (_select$41 = select[0]) === null || _select$41 === void 0 ? void 0 : _select$41[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_number_learning_group_1'
        },
        pyHelpDef: {
          params: [],
          type: 'is_number_learning_group_1'
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_1'],
        paramsKeyMap: {
          ATTR1: 1,
          CLASS: 2
        },
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12() {
            var x, clazz, _Entry$aiLearning$get141, _Entry$aiLearning$get142, className;
            return _regenerator["default"].wrap(function (_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  clazz = script.getField('CLASS', script);
                  _context12.next = 1;
                  return Entry.aiLearning.predict([x]);
                case 1:
                  _Entry$aiLearning$get141 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get142 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get141, 1), className = _Entry$aiLearning$get142[0].className;
                  return _context12.abrupt("return", className === clazz);
                case 2:
                case "end":
                  return _context12.stop();
              }
            }, _callee12);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_number_learning_group_2: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning85, _Entry$aiLearning85$g;
            var table = (_Entry$aiLearning85 = Entry.aiLearning) === null || _Entry$aiLearning85 === void 0 || (_Entry$aiLearning85$g = _Entry$aiLearning85.getTableData) === null || _Entry$aiLearning85$g === void 0 ? void 0 : _Entry$aiLearning85$g.call(_Entry$aiLearning85);
            if (table) {
              var _Entry$aiLearning86, _Entry$aiLearning86$g, _select$42;
              var _Entry$aiLearning$get143 = (_Entry$aiLearning86 = Entry.aiLearning) === null || _Entry$aiLearning86 === void 0 || (_Entry$aiLearning86$g = _Entry$aiLearning86.getTableData) === null || _Entry$aiLearning86$g === void 0 ? void 0 : _Entry$aiLearning86$g.call(_Entry$aiLearning86),
                _Entry$aiLearning$get144 = _Entry$aiLearning$get143.select,
                select = _Entry$aiLearning$get144 === void 0 ? [] : _Entry$aiLearning$get144,
                _Entry$aiLearning$get145 = _Entry$aiLearning$get143.fields,
                fields = _Entry$aiLearning$get145 === void 0 ? [] : _Entry$aiLearning$get145;
              return fields[select === null || select === void 0 || (_select$42 = select[0]) === null || _select$42 === void 0 ? void 0 : _select$42[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning87, _Entry$aiLearning87$g;
            var table = (_Entry$aiLearning87 = Entry.aiLearning) === null || _Entry$aiLearning87 === void 0 || (_Entry$aiLearning87$g = _Entry$aiLearning87.getTableData) === null || _Entry$aiLearning87$g === void 0 ? void 0 : _Entry$aiLearning87$g.call(_Entry$aiLearning87);
            if (table) {
              var _Entry$aiLearning88, _Entry$aiLearning88$g, _select$43;
              var _Entry$aiLearning$get146 = (_Entry$aiLearning88 = Entry.aiLearning) === null || _Entry$aiLearning88 === void 0 || (_Entry$aiLearning88$g = _Entry$aiLearning88.getTableData) === null || _Entry$aiLearning88$g === void 0 ? void 0 : _Entry$aiLearning88$g.call(_Entry$aiLearning88),
                _Entry$aiLearning$get147 = _Entry$aiLearning$get146.select,
                select = _Entry$aiLearning$get147 === void 0 ? [] : _Entry$aiLearning$get147,
                _Entry$aiLearning$get148 = _Entry$aiLearning$get146.fields,
                fields = _Entry$aiLearning$get148 === void 0 ? [] : _Entry$aiLearning$get148;
              return fields[select === null || select === void 0 || (_select$43 = select[0]) === null || _select$43 === void 0 ? void 0 : _select$43[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_number_learning_group_2'
        },
        pyHelpDef: {
          params: [],
          type: 'is_number_learning_group_2'
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_2'],
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          CLASS: 4
        },
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee13() {
            var x, y, clazz, _Entry$aiLearning$get149, _Entry$aiLearning$get150, className;
            return _regenerator["default"].wrap(function (_context13) {
              while (1) switch (_context13.prev = _context13.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  clazz = script.getField('CLASS', script);
                  _context13.next = 1;
                  return Entry.aiLearning.predict([x, y]);
                case 1:
                  _Entry$aiLearning$get149 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get150 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get149, 1), className = _Entry$aiLearning$get150[0].className;
                  return _context13.abrupt("return", className === clazz);
                case 2:
                case "end":
                  return _context13.stop();
              }
            }, _callee13);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_number_learning_group_3: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning89, _Entry$aiLearning89$g;
            var table = (_Entry$aiLearning89 = Entry.aiLearning) === null || _Entry$aiLearning89 === void 0 || (_Entry$aiLearning89$g = _Entry$aiLearning89.getTableData) === null || _Entry$aiLearning89$g === void 0 ? void 0 : _Entry$aiLearning89$g.call(_Entry$aiLearning89);
            if (table) {
              var _Entry$aiLearning90, _Entry$aiLearning90$g, _select$44;
              var _Entry$aiLearning$get151 = (_Entry$aiLearning90 = Entry.aiLearning) === null || _Entry$aiLearning90 === void 0 || (_Entry$aiLearning90$g = _Entry$aiLearning90.getTableData) === null || _Entry$aiLearning90$g === void 0 ? void 0 : _Entry$aiLearning90$g.call(_Entry$aiLearning90),
                _Entry$aiLearning$get152 = _Entry$aiLearning$get151.select,
                select = _Entry$aiLearning$get152 === void 0 ? [] : _Entry$aiLearning$get152,
                _Entry$aiLearning$get153 = _Entry$aiLearning$get151.fields,
                fields = _Entry$aiLearning$get153 === void 0 ? [] : _Entry$aiLearning$get153;
              return fields[select === null || select === void 0 || (_select$44 = select[0]) === null || _select$44 === void 0 ? void 0 : _select$44[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning91, _Entry$aiLearning91$g;
            var table = (_Entry$aiLearning91 = Entry.aiLearning) === null || _Entry$aiLearning91 === void 0 || (_Entry$aiLearning91$g = _Entry$aiLearning91.getTableData) === null || _Entry$aiLearning91$g === void 0 ? void 0 : _Entry$aiLearning91$g.call(_Entry$aiLearning91);
            if (table) {
              var _Entry$aiLearning92, _Entry$aiLearning92$g, _select$45;
              var _Entry$aiLearning$get154 = (_Entry$aiLearning92 = Entry.aiLearning) === null || _Entry$aiLearning92 === void 0 || (_Entry$aiLearning92$g = _Entry$aiLearning92.getTableData) === null || _Entry$aiLearning92$g === void 0 ? void 0 : _Entry$aiLearning92$g.call(_Entry$aiLearning92),
                _Entry$aiLearning$get155 = _Entry$aiLearning$get154.select,
                select = _Entry$aiLearning$get155 === void 0 ? [] : _Entry$aiLearning$get155,
                _Entry$aiLearning$get156 = _Entry$aiLearning$get154.fields,
                fields = _Entry$aiLearning$get156 === void 0 ? [] : _Entry$aiLearning$get156;
              return fields[select === null || select === void 0 || (_select$45 = select[0]) === null || _select$45 === void 0 ? void 0 : _select$45[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning93, _Entry$aiLearning93$g;
            var table = (_Entry$aiLearning93 = Entry.aiLearning) === null || _Entry$aiLearning93 === void 0 || (_Entry$aiLearning93$g = _Entry$aiLearning93.getTableData) === null || _Entry$aiLearning93$g === void 0 ? void 0 : _Entry$aiLearning93$g.call(_Entry$aiLearning93);
            if (table) {
              var _Entry$aiLearning94, _Entry$aiLearning94$g, _select$46;
              var _Entry$aiLearning$get157 = (_Entry$aiLearning94 = Entry.aiLearning) === null || _Entry$aiLearning94 === void 0 || (_Entry$aiLearning94$g = _Entry$aiLearning94.getTableData) === null || _Entry$aiLearning94$g === void 0 ? void 0 : _Entry$aiLearning94$g.call(_Entry$aiLearning94),
                _Entry$aiLearning$get158 = _Entry$aiLearning$get157.select,
                select = _Entry$aiLearning$get158 === void 0 ? [] : _Entry$aiLearning$get158,
                _Entry$aiLearning$get159 = _Entry$aiLearning$get157.fields,
                fields = _Entry$aiLearning$get159 === void 0 ? [] : _Entry$aiLearning$get159;
              return fields[select === null || select === void 0 || (_select$46 = select[0]) === null || _select$46 === void 0 ? void 0 : _select$46[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_number_learning_group_3'
        },
        pyHelpDef: {
          params: [],
          type: 'is_number_learning_group_3'
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_3'],
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          CLASS: 6
        },
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee14() {
            var x, y, z, clazz, _Entry$aiLearning$get160, _Entry$aiLearning$get161, className;
            return _regenerator["default"].wrap(function (_context14) {
              while (1) switch (_context14.prev = _context14.next) {
                case 0:
                  x = script.getNumberValue('ATTR1', script);
                  y = script.getNumberValue('ATTR2', script);
                  z = script.getNumberValue('ATTR3', script);
                  clazz = script.getField('CLASS', script);
                  _context14.next = 1;
                  return Entry.aiLearning.predict([x, y, z]);
                case 1:
                  _Entry$aiLearning$get160 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get161 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get160, 1), className = _Entry$aiLearning$get161[0].className;
                  return _context14.abrupt("return", className === clazz);
                case 2:
                case "end":
                  return _context14.stop();
              }
            }, _callee14);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_number_learning_group_4: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning95, _Entry$aiLearning95$g;
            var table = (_Entry$aiLearning95 = Entry.aiLearning) === null || _Entry$aiLearning95 === void 0 || (_Entry$aiLearning95$g = _Entry$aiLearning95.getTableData) === null || _Entry$aiLearning95$g === void 0 ? void 0 : _Entry$aiLearning95$g.call(_Entry$aiLearning95);
            if (table) {
              var _Entry$aiLearning96, _Entry$aiLearning96$g, _select$47;
              var _Entry$aiLearning$get162 = (_Entry$aiLearning96 = Entry.aiLearning) === null || _Entry$aiLearning96 === void 0 || (_Entry$aiLearning96$g = _Entry$aiLearning96.getTableData) === null || _Entry$aiLearning96$g === void 0 ? void 0 : _Entry$aiLearning96$g.call(_Entry$aiLearning96),
                _Entry$aiLearning$get163 = _Entry$aiLearning$get162.select,
                select = _Entry$aiLearning$get163 === void 0 ? [] : _Entry$aiLearning$get163,
                _Entry$aiLearning$get164 = _Entry$aiLearning$get162.fields,
                fields = _Entry$aiLearning$get164 === void 0 ? [] : _Entry$aiLearning$get164;
              return fields[select === null || select === void 0 || (_select$47 = select[0]) === null || _select$47 === void 0 ? void 0 : _select$47[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning97, _Entry$aiLearning97$g;
            var table = (_Entry$aiLearning97 = Entry.aiLearning) === null || _Entry$aiLearning97 === void 0 || (_Entry$aiLearning97$g = _Entry$aiLearning97.getTableData) === null || _Entry$aiLearning97$g === void 0 ? void 0 : _Entry$aiLearning97$g.call(_Entry$aiLearning97);
            if (table) {
              var _Entry$aiLearning98, _Entry$aiLearning98$g, _select$48;
              var _Entry$aiLearning$get165 = (_Entry$aiLearning98 = Entry.aiLearning) === null || _Entry$aiLearning98 === void 0 || (_Entry$aiLearning98$g = _Entry$aiLearning98.getTableData) === null || _Entry$aiLearning98$g === void 0 ? void 0 : _Entry$aiLearning98$g.call(_Entry$aiLearning98),
                _Entry$aiLearning$get166 = _Entry$aiLearning$get165.select,
                select = _Entry$aiLearning$get166 === void 0 ? [] : _Entry$aiLearning$get166,
                _Entry$aiLearning$get167 = _Entry$aiLearning$get165.fields,
                fields = _Entry$aiLearning$get167 === void 0 ? [] : _Entry$aiLearning$get167;
              return fields[select === null || select === void 0 || (_select$48 = select[0]) === null || _select$48 === void 0 ? void 0 : _select$48[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning99, _Entry$aiLearning99$g;
            var table = (_Entry$aiLearning99 = Entry.aiLearning) === null || _Entry$aiLearning99 === void 0 || (_Entry$aiLearning99$g = _Entry$aiLearning99.getTableData) === null || _Entry$aiLearning99$g === void 0 ? void 0 : _Entry$aiLearning99$g.call(_Entry$aiLearning99);
            if (table) {
              var _Entry$aiLearning100, _Entry$aiLearning100$, _select$49;
              var _Entry$aiLearning$get168 = (_Entry$aiLearning100 = Entry.aiLearning) === null || _Entry$aiLearning100 === void 0 || (_Entry$aiLearning100$ = _Entry$aiLearning100.getTableData) === null || _Entry$aiLearning100$ === void 0 ? void 0 : _Entry$aiLearning100$.call(_Entry$aiLearning100),
                _Entry$aiLearning$get169 = _Entry$aiLearning$get168.select,
                select = _Entry$aiLearning$get169 === void 0 ? [] : _Entry$aiLearning$get169,
                _Entry$aiLearning$get170 = _Entry$aiLearning$get168.fields,
                fields = _Entry$aiLearning$get170 === void 0 ? [] : _Entry$aiLearning$get170;
              return fields[select === null || select === void 0 || (_select$49 = select[0]) === null || _select$49 === void 0 ? void 0 : _select$49[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning101, _Entry$aiLearning101$;
            var table = (_Entry$aiLearning101 = Entry.aiLearning) === null || _Entry$aiLearning101 === void 0 || (_Entry$aiLearning101$ = _Entry$aiLearning101.getTableData) === null || _Entry$aiLearning101$ === void 0 ? void 0 : _Entry$aiLearning101$.call(_Entry$aiLearning101);
            if (table) {
              var _Entry$aiLearning102, _Entry$aiLearning102$, _select$50;
              var _Entry$aiLearning$get171 = (_Entry$aiLearning102 = Entry.aiLearning) === null || _Entry$aiLearning102 === void 0 || (_Entry$aiLearning102$ = _Entry$aiLearning102.getTableData) === null || _Entry$aiLearning102$ === void 0 ? void 0 : _Entry$aiLearning102$.call(_Entry$aiLearning102),
                _Entry$aiLearning$get172 = _Entry$aiLearning$get171.select,
                select = _Entry$aiLearning$get172 === void 0 ? [] : _Entry$aiLearning$get172,
                _Entry$aiLearning$get173 = _Entry$aiLearning$get171.fields,
                fields = _Entry$aiLearning$get173 === void 0 ? [] : _Entry$aiLearning$get173;
              return fields[select === null || select === void 0 || (_select$50 = select[0]) === null || _select$50 === void 0 ? void 0 : _select$50[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_number_learning_group_4'
        },
        pyHelpDef: {
          params: [],
          type: 'is_number_learning_group_4'
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_4'],
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          CLASS: 8
        },
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee15() {
            var a, b, c, d, clazz, _Entry$aiLearning$get174, _Entry$aiLearning$get175, className;
            return _regenerator["default"].wrap(function (_context15) {
              while (1) switch (_context15.prev = _context15.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  clazz = script.getField('CLASS', script);
                  _context15.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d]);
                case 1:
                  _Entry$aiLearning$get174 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get175 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get174, 1), className = _Entry$aiLearning$get175[0].className;
                  return _context15.abrupt("return", className === clazz);
                case 2:
                case "end":
                  return _context15.stop();
              }
            }, _callee15);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_number_learning_group_5: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning103, _Entry$aiLearning103$;
            var table = (_Entry$aiLearning103 = Entry.aiLearning) === null || _Entry$aiLearning103 === void 0 || (_Entry$aiLearning103$ = _Entry$aiLearning103.getTableData) === null || _Entry$aiLearning103$ === void 0 ? void 0 : _Entry$aiLearning103$.call(_Entry$aiLearning103);
            if (table) {
              var _Entry$aiLearning104, _Entry$aiLearning104$, _select$51;
              var _Entry$aiLearning$get176 = (_Entry$aiLearning104 = Entry.aiLearning) === null || _Entry$aiLearning104 === void 0 || (_Entry$aiLearning104$ = _Entry$aiLearning104.getTableData) === null || _Entry$aiLearning104$ === void 0 ? void 0 : _Entry$aiLearning104$.call(_Entry$aiLearning104),
                _Entry$aiLearning$get177 = _Entry$aiLearning$get176.select,
                select = _Entry$aiLearning$get177 === void 0 ? [] : _Entry$aiLearning$get177,
                _Entry$aiLearning$get178 = _Entry$aiLearning$get176.fields,
                fields = _Entry$aiLearning$get178 === void 0 ? [] : _Entry$aiLearning$get178;
              return fields[select === null || select === void 0 || (_select$51 = select[0]) === null || _select$51 === void 0 ? void 0 : _select$51[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning105, _Entry$aiLearning105$;
            var table = (_Entry$aiLearning105 = Entry.aiLearning) === null || _Entry$aiLearning105 === void 0 || (_Entry$aiLearning105$ = _Entry$aiLearning105.getTableData) === null || _Entry$aiLearning105$ === void 0 ? void 0 : _Entry$aiLearning105$.call(_Entry$aiLearning105);
            if (table) {
              var _Entry$aiLearning106, _Entry$aiLearning106$, _select$52;
              var _Entry$aiLearning$get179 = (_Entry$aiLearning106 = Entry.aiLearning) === null || _Entry$aiLearning106 === void 0 || (_Entry$aiLearning106$ = _Entry$aiLearning106.getTableData) === null || _Entry$aiLearning106$ === void 0 ? void 0 : _Entry$aiLearning106$.call(_Entry$aiLearning106),
                _Entry$aiLearning$get180 = _Entry$aiLearning$get179.select,
                select = _Entry$aiLearning$get180 === void 0 ? [] : _Entry$aiLearning$get180,
                _Entry$aiLearning$get181 = _Entry$aiLearning$get179.fields,
                fields = _Entry$aiLearning$get181 === void 0 ? [] : _Entry$aiLearning$get181;
              return fields[select === null || select === void 0 || (_select$52 = select[0]) === null || _select$52 === void 0 ? void 0 : _select$52[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning107, _Entry$aiLearning107$;
            var table = (_Entry$aiLearning107 = Entry.aiLearning) === null || _Entry$aiLearning107 === void 0 || (_Entry$aiLearning107$ = _Entry$aiLearning107.getTableData) === null || _Entry$aiLearning107$ === void 0 ? void 0 : _Entry$aiLearning107$.call(_Entry$aiLearning107);
            if (table) {
              var _Entry$aiLearning108, _Entry$aiLearning108$, _select$53;
              var _Entry$aiLearning$get182 = (_Entry$aiLearning108 = Entry.aiLearning) === null || _Entry$aiLearning108 === void 0 || (_Entry$aiLearning108$ = _Entry$aiLearning108.getTableData) === null || _Entry$aiLearning108$ === void 0 ? void 0 : _Entry$aiLearning108$.call(_Entry$aiLearning108),
                _Entry$aiLearning$get183 = _Entry$aiLearning$get182.select,
                select = _Entry$aiLearning$get183 === void 0 ? [] : _Entry$aiLearning$get183,
                _Entry$aiLearning$get184 = _Entry$aiLearning$get182.fields,
                fields = _Entry$aiLearning$get184 === void 0 ? [] : _Entry$aiLearning$get184;
              return fields[select === null || select === void 0 || (_select$53 = select[0]) === null || _select$53 === void 0 ? void 0 : _select$53[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning109, _Entry$aiLearning109$;
            var table = (_Entry$aiLearning109 = Entry.aiLearning) === null || _Entry$aiLearning109 === void 0 || (_Entry$aiLearning109$ = _Entry$aiLearning109.getTableData) === null || _Entry$aiLearning109$ === void 0 ? void 0 : _Entry$aiLearning109$.call(_Entry$aiLearning109);
            if (table) {
              var _Entry$aiLearning110, _Entry$aiLearning110$, _select$54;
              var _Entry$aiLearning$get185 = (_Entry$aiLearning110 = Entry.aiLearning) === null || _Entry$aiLearning110 === void 0 || (_Entry$aiLearning110$ = _Entry$aiLearning110.getTableData) === null || _Entry$aiLearning110$ === void 0 ? void 0 : _Entry$aiLearning110$.call(_Entry$aiLearning110),
                _Entry$aiLearning$get186 = _Entry$aiLearning$get185.select,
                select = _Entry$aiLearning$get186 === void 0 ? [] : _Entry$aiLearning$get186,
                _Entry$aiLearning$get187 = _Entry$aiLearning$get185.fields,
                fields = _Entry$aiLearning$get187 === void 0 ? [] : _Entry$aiLearning$get187;
              return fields[select === null || select === void 0 || (_select$54 = select[0]) === null || _select$54 === void 0 ? void 0 : _select$54[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning111, _Entry$aiLearning111$;
            var table = (_Entry$aiLearning111 = Entry.aiLearning) === null || _Entry$aiLearning111 === void 0 || (_Entry$aiLearning111$ = _Entry$aiLearning111.getTableData) === null || _Entry$aiLearning111$ === void 0 ? void 0 : _Entry$aiLearning111$.call(_Entry$aiLearning111);
            if (table) {
              var _Entry$aiLearning112, _Entry$aiLearning112$, _select$55;
              var _Entry$aiLearning$get188 = (_Entry$aiLearning112 = Entry.aiLearning) === null || _Entry$aiLearning112 === void 0 || (_Entry$aiLearning112$ = _Entry$aiLearning112.getTableData) === null || _Entry$aiLearning112$ === void 0 ? void 0 : _Entry$aiLearning112$.call(_Entry$aiLearning112),
                _Entry$aiLearning$get189 = _Entry$aiLearning$get188.select,
                select = _Entry$aiLearning$get189 === void 0 ? [] : _Entry$aiLearning$get189,
                _Entry$aiLearning$get190 = _Entry$aiLearning$get188.fields,
                fields = _Entry$aiLearning$get190 === void 0 ? [] : _Entry$aiLearning$get190;
              return fields[select === null || select === void 0 || (_select$55 = select[0]) === null || _select$55 === void 0 ? void 0 : _select$55[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_number_learning_group_5'
        },
        pyHelpDef: {
          params: [],
          type: 'is_number_learning_group_5'
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_5'],
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9,
          CLASS: 10
        },
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee16() {
            var a, b, c, d, e, clazz, _Entry$aiLearning$get191, _Entry$aiLearning$get192, className;
            return _regenerator["default"].wrap(function (_context16) {
              while (1) switch (_context16.prev = _context16.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  clazz = script.getField('CLASS', script);
                  _context16.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e]);
                case 1:
                  _Entry$aiLearning$get191 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get192 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get191, 1), className = _Entry$aiLearning$get192[0].className;
                  return _context16.abrupt("return", className === clazz);
                case 2:
                case "end":
                  return _context16.stop();
              }
            }, _callee16);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_number_learning_group_6: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning113, _Entry$aiLearning113$;
            var table = (_Entry$aiLearning113 = Entry.aiLearning) === null || _Entry$aiLearning113 === void 0 || (_Entry$aiLearning113$ = _Entry$aiLearning113.getTableData) === null || _Entry$aiLearning113$ === void 0 ? void 0 : _Entry$aiLearning113$.call(_Entry$aiLearning113);
            if (table) {
              var _Entry$aiLearning114, _Entry$aiLearning114$, _select$56;
              var _Entry$aiLearning$get193 = (_Entry$aiLearning114 = Entry.aiLearning) === null || _Entry$aiLearning114 === void 0 || (_Entry$aiLearning114$ = _Entry$aiLearning114.getTableData) === null || _Entry$aiLearning114$ === void 0 ? void 0 : _Entry$aiLearning114$.call(_Entry$aiLearning114),
                _Entry$aiLearning$get194 = _Entry$aiLearning$get193.select,
                select = _Entry$aiLearning$get194 === void 0 ? [] : _Entry$aiLearning$get194,
                _Entry$aiLearning$get195 = _Entry$aiLearning$get193.fields,
                fields = _Entry$aiLearning$get195 === void 0 ? [] : _Entry$aiLearning$get195;
              return fields[select === null || select === void 0 || (_select$56 = select[0]) === null || _select$56 === void 0 ? void 0 : _select$56[0]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning115, _Entry$aiLearning115$;
            var table = (_Entry$aiLearning115 = Entry.aiLearning) === null || _Entry$aiLearning115 === void 0 || (_Entry$aiLearning115$ = _Entry$aiLearning115.getTableData) === null || _Entry$aiLearning115$ === void 0 ? void 0 : _Entry$aiLearning115$.call(_Entry$aiLearning115);
            if (table) {
              var _Entry$aiLearning116, _Entry$aiLearning116$, _select$57;
              var _Entry$aiLearning$get196 = (_Entry$aiLearning116 = Entry.aiLearning) === null || _Entry$aiLearning116 === void 0 || (_Entry$aiLearning116$ = _Entry$aiLearning116.getTableData) === null || _Entry$aiLearning116$ === void 0 ? void 0 : _Entry$aiLearning116$.call(_Entry$aiLearning116),
                _Entry$aiLearning$get197 = _Entry$aiLearning$get196.select,
                select = _Entry$aiLearning$get197 === void 0 ? [] : _Entry$aiLearning$get197,
                _Entry$aiLearning$get198 = _Entry$aiLearning$get196.fields,
                fields = _Entry$aiLearning$get198 === void 0 ? [] : _Entry$aiLearning$get198;
              return fields[select === null || select === void 0 || (_select$57 = select[0]) === null || _select$57 === void 0 ? void 0 : _select$57[1]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning117, _Entry$aiLearning117$;
            var table = (_Entry$aiLearning117 = Entry.aiLearning) === null || _Entry$aiLearning117 === void 0 || (_Entry$aiLearning117$ = _Entry$aiLearning117.getTableData) === null || _Entry$aiLearning117$ === void 0 ? void 0 : _Entry$aiLearning117$.call(_Entry$aiLearning117);
            if (table) {
              var _Entry$aiLearning118, _Entry$aiLearning118$, _select$58;
              var _Entry$aiLearning$get199 = (_Entry$aiLearning118 = Entry.aiLearning) === null || _Entry$aiLearning118 === void 0 || (_Entry$aiLearning118$ = _Entry$aiLearning118.getTableData) === null || _Entry$aiLearning118$ === void 0 ? void 0 : _Entry$aiLearning118$.call(_Entry$aiLearning118),
                _Entry$aiLearning$get200 = _Entry$aiLearning$get199.select,
                select = _Entry$aiLearning$get200 === void 0 ? [] : _Entry$aiLearning$get200,
                _Entry$aiLearning$get201 = _Entry$aiLearning$get199.fields,
                fields = _Entry$aiLearning$get201 === void 0 ? [] : _Entry$aiLearning$get201;
              return fields[select === null || select === void 0 || (_select$58 = select[0]) === null || _select$58 === void 0 ? void 0 : _select$58[2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning119, _Entry$aiLearning119$;
            var table = (_Entry$aiLearning119 = Entry.aiLearning) === null || _Entry$aiLearning119 === void 0 || (_Entry$aiLearning119$ = _Entry$aiLearning119.getTableData) === null || _Entry$aiLearning119$ === void 0 ? void 0 : _Entry$aiLearning119$.call(_Entry$aiLearning119);
            if (table) {
              var _Entry$aiLearning120, _Entry$aiLearning120$, _select$59;
              var _Entry$aiLearning$get202 = (_Entry$aiLearning120 = Entry.aiLearning) === null || _Entry$aiLearning120 === void 0 || (_Entry$aiLearning120$ = _Entry$aiLearning120.getTableData) === null || _Entry$aiLearning120$ === void 0 ? void 0 : _Entry$aiLearning120$.call(_Entry$aiLearning120),
                _Entry$aiLearning$get203 = _Entry$aiLearning$get202.select,
                select = _Entry$aiLearning$get203 === void 0 ? [] : _Entry$aiLearning$get203,
                _Entry$aiLearning$get204 = _Entry$aiLearning$get202.fields,
                fields = _Entry$aiLearning$get204 === void 0 ? [] : _Entry$aiLearning$get204;
              return fields[select === null || select === void 0 || (_select$59 = select[0]) === null || _select$59 === void 0 ? void 0 : _select$59[3]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning121, _Entry$aiLearning121$;
            var table = (_Entry$aiLearning121 = Entry.aiLearning) === null || _Entry$aiLearning121 === void 0 || (_Entry$aiLearning121$ = _Entry$aiLearning121.getTableData) === null || _Entry$aiLearning121$ === void 0 ? void 0 : _Entry$aiLearning121$.call(_Entry$aiLearning121);
            if (table) {
              var _Entry$aiLearning122, _Entry$aiLearning122$, _select$60;
              var _Entry$aiLearning$get205 = (_Entry$aiLearning122 = Entry.aiLearning) === null || _Entry$aiLearning122 === void 0 || (_Entry$aiLearning122$ = _Entry$aiLearning122.getTableData) === null || _Entry$aiLearning122$ === void 0 ? void 0 : _Entry$aiLearning122$.call(_Entry$aiLearning122),
                _Entry$aiLearning$get206 = _Entry$aiLearning$get205.select,
                select = _Entry$aiLearning$get206 === void 0 ? [] : _Entry$aiLearning$get206,
                _Entry$aiLearning$get207 = _Entry$aiLearning$get205.fields,
                fields = _Entry$aiLearning$get207 === void 0 ? [] : _Entry$aiLearning$get207;
              return fields[select === null || select === void 0 || (_select$60 = select[0]) === null || _select$60 === void 0 ? void 0 : _select$60[4]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning123, _Entry$aiLearning123$;
            var table = (_Entry$aiLearning123 = Entry.aiLearning) === null || _Entry$aiLearning123 === void 0 || (_Entry$aiLearning123$ = _Entry$aiLearning123.getTableData) === null || _Entry$aiLearning123$ === void 0 ? void 0 : _Entry$aiLearning123$.call(_Entry$aiLearning123);
            if (table) {
              var _Entry$aiLearning124, _Entry$aiLearning124$, _select$61;
              var _Entry$aiLearning$get208 = (_Entry$aiLearning124 = Entry.aiLearning) === null || _Entry$aiLearning124 === void 0 || (_Entry$aiLearning124$ = _Entry$aiLearning124.getTableData) === null || _Entry$aiLearning124$ === void 0 ? void 0 : _Entry$aiLearning124$.call(_Entry$aiLearning124),
                _Entry$aiLearning$get209 = _Entry$aiLearning$get208.select,
                select = _Entry$aiLearning$get209 === void 0 ? [] : _Entry$aiLearning$get209,
                _Entry$aiLearning$get210 = _Entry$aiLearning$get208.fields,
                fields = _Entry$aiLearning$get210 === void 0 ? [] : _Entry$aiLearning$get210;
              return fields[select === null || select === void 0 || (_select$61 = select[0]) === null || _select$61 === void 0 ? void 0 : _select$61[5]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'DropdownDynamic',
          value: null,
          menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_number_learning_group_6'
        },
        pyHelpDef: {
          params: [],
          type: 'is_number_learning_group_6'
        },
        "class": 'ai_learning',
        isNotFor: ['number_learning_attr_6'],
        paramsKeyMap: {
          ATTR1: 1,
          ATTR2: 3,
          ATTR3: 5,
          ATTR4: 7,
          ATTR5: 9,
          ATTR6: 11,
          CLASS: 12
        },
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee17() {
            var a, b, c, d, e, f, clazz, _Entry$aiLearning$get211, _Entry$aiLearning$get212, className;
            return _regenerator["default"].wrap(function (_context17) {
              while (1) switch (_context17.prev = _context17.next) {
                case 0:
                  a = script.getNumberValue('ATTR1', script);
                  b = script.getNumberValue('ATTR2', script);
                  c = script.getNumberValue('ATTR3', script);
                  d = script.getNumberValue('ATTR4', script);
                  e = script.getNumberValue('ATTR5', script);
                  f = script.getNumberValue('ATTR6', script);
                  clazz = script.getField('CLASS', script);
                  _context17.next = 1;
                  return Entry.aiLearning.predict([a, b, c, d, e, f]);
                case 1:
                  _Entry$aiLearning$get211 = Entry.aiLearning.getPredictResult(), _Entry$aiLearning$get212 = (0, _slicedToArray2["default"])(_Entry$aiLearning$get211, 1), className = _Entry$aiLearning$get212[0].className;
                  return _context17.abrupt("return", className === clazz);
                case 2:
                case "end":
                  return _context17.stop();
              }
            }, _callee17);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      }
    };
  }
};